import springReportsApi from '../../services/springReportsApi'

export const login = data => (
	new Promise((resolve, reject) => {
		springReportsApi()
			.post('/auth/login', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const logout = () => (
	new Promise((resolve, reject) => {
		springReportsApi()
			.post('/auth/logout')
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)